import { IUserResponse } from '@kcftech/prometheustypescriptapiclient';
import { usePermissions } from 'contexts/PermissionsContext';
import { CorporationUserRoleCell } from 'pages/Settings/Users/table_cells/CorporationUserRoleCell';
import { LocationUserRoleCell } from 'pages/Settings/Users/table_cells/LocationUserRoleCell';
import { UserApplicationRoleCodeCell } from 'pages/Settings/Users/table_cells/UserApplicationRoleCodeCell';

export type UserRoleCellProps = Readonly<{
    corporationId?: string;
    locationId?: string;
    rowData: IUserResponse;
    onChange: () => void;
}>;

export function UserRoleCell({
    corporationId,
    locationId,
    rowData,
    onChange,
}: UserRoleCellProps) {
    const {
        canEditUserCorporationAssignment,
        canEditUserLocationAssignment,
    } = usePermissions();
    if (locationId && corporationId) {
        return (
            <LocationUserRoleCell
                locationId={locationId}
                rowData={rowData}
                onChange={onChange}
                disabled={!canEditUserLocationAssignment(corporationId, locationId)}
            />
        );
    }
    if (corporationId) {
        return (
            <CorporationUserRoleCell
                corporationId={corporationId}
                rowData={rowData}
                onChange={onChange}
                disabled={!canEditUserCorporationAssignment(corporationId)}
            />
        );
    }
    return <UserApplicationRoleCodeCell rowData={rowData} onChange={onChange} />;
}
